import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectOfferSellerTypes = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('offer_seller_type')(jsonQuery),
);
